// import UnderLine from '../../components/ExcerciseTypes/Design/UnderLine';
import UI from '../../components/ExcerciseTypes/Design/UserInterface';
import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';

const json = {
  1: { // Exercise num
    unit: 'Unit 1',
    id: 'SB4-U1-P11-E1',
    audio: 'img/FriendsPlus/Page11/Audio/audio-e1-p11.mp3',
    recorder: true,
    video: '',
    component: UI,
    questionImage: [ // Row
      [
        { url: 'img/FriendsPlus/Page11/E1/1.jpg' },
        { url: 'img/FriendsPlus/Page11/E1/2.jpg', audioUrl: 'img/FriendsPlus/Page11/Audio/tieude-e1-p11.mp3' },
        { url: 'img/FriendsPlus/Page11/E1/3.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page11/E1/4.jpg', audioUrl: 'img/FriendsPlus/Page11/Audio/hinh1-e1-p11.mp3' },
        { url: 'img/FriendsPlus/Page11/E1/5.jpg', audioUrl: 'img/FriendsPlus/Page11/Audio/hinh2-e1-p11.mp3' },
        { url: 'img/FriendsPlus/Page11/E1/6.jpg', audioUrl: 'img/FriendsPlus/Page11/Audio/hinh3-e1-p11.mp3' },
        { url: 'img/FriendsPlus/Page11/E1/7.jpg', audioUrl: 'img/FriendsPlus/Page11/Audio/hinh4-e1-p11.mp3' },
        { url: 'img/FriendsPlus/Page11/E1/8.jpg', audioUrl: 'img/FriendsPlus/Page11/Audio/hinh5-e1-p11.mp3' },
        { url: 'img/FriendsPlus/Page11/E1/9.jpg', audioUrl: 'img/FriendsPlus/Page11/Audio/hinh6-e1-p11.mp3' },
      ]
    ],
  },

  2: { // Exercise num
    unit: 'Unit 1',
    id: 'SB4-U1-P11-E2',
    audio: 'img/FriendsPlus/Page11/Audio/audio-e2-p11.mp3',
    video: '',
    recorder: true,
    component: UI,
    questionImage: [ // Row
      [
        { url: 'img/FriendsPlus/Page11/E2/1.jpg' },
        { url: 'img/FriendsPlus/Page11/E2/2.jpg', audioUrl: 'img/FriendsPlus/Page11/Audio/tieude-e2-p11.mp3' },
        { url: 'img/FriendsPlus/Page11/E2/3.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page11/E2/4.jpg' },
      ]
    ],
  },
  3: { // Exercise num
    unit: 'Unit 1',
    id: 'SB4-U1-P11-E3',
    audio: '',
    video: '',
    totalInput: 3,
    exerciseKey: 'img/FriendsPlus/Page11/E3/Key/answerKey.png',
    component: DesignUnderLine,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page11/E3/0.jpg' },
      ],
      [
        // Column1
        { url: 'img/FriendsPlus/Page11/E3/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page11/E3/2.jpg' },
        { url: 'img/FriendsPlus/Page11/E3/3.jpg', input: 1, },
        { url: 'img/FriendsPlus/Page11/E3/4.jpg' },
        { url: 'img/FriendsPlus/Page11/E3/5.jpg', input: 2, },
        { url: 'img/FriendsPlus/Page11/E3/6.jpg', input: 3, },
        { url: 'img/FriendsPlus/Page11/E3/7.jpg', input: 4, },
        { url: 'img/FriendsPlus/Page11/E3/8.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page11/E3/9.jpg' },
        { url: 'img/FriendsPlus/Page11/E3/10.jpg', input: 5, },
        { url: 'img/FriendsPlus/Page11/E3/11.jpg', input: 6, },
        { url: 'img/FriendsPlus/Page11/E3/12.jpg', input: 7, },
        { url: 'img/FriendsPlus/Page11/E3/13.jpg', input: 8, },
        { url: 'img/FriendsPlus/Page11/E3/14.jpg', input: 9, isCorrect: true },
        { url: 'img/FriendsPlus/Page11/E3/15.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page11/E3/16.jpg' },
        { url: 'img/FriendsPlus/Page11/E3/17.jpg', input: 10, },
        { url: 'img/FriendsPlus/Page11/E3/18.jpg', input: 11, },
        { url: 'img/FriendsPlus/Page11/E3/19.jpg', input: 12, },
        { url: 'img/FriendsPlus/Page11/E3/20.jpg', input: 13, },
        { url: 'img/FriendsPlus/Page11/E3/21.jpg', input: 14, isCorrect: true },
        { url: 'img/FriendsPlus/Page11/E3/22.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page11/E3/23.jpg' },
        { url: 'img/FriendsPlus/Page11/E3/24.jpg', input: 15, },
        { url: 'img/FriendsPlus/Page11/E3/25.jpg', input: 16, isCorrect: true },
        { url: 'img/FriendsPlus/Page11/E3/26.jpg', input: 17, },
        { url: 'img/FriendsPlus/Page11/E3/27.jpg', input: 18, },
        { url: 'img/FriendsPlus/Page11/E3/28.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page11/E3/29.jpg' },
      ],




    ],
  },
  4: { // Exercise num
    unit: 'Unit 1',
    id: 'SB4-U1-P11-E4',
    audio: 'img/FriendsPlus/Page11/Audio/audio-e4-p11.mp3',
    video: '',
    totalInput: 7,
    exerciseKey: 'img/FriendsPlus/Page11/E4/Key/answerKey.png',
    component: DesignUnderLine,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page11/E4/1.jpg' },
        { url: 'img/FriendsPlus/Page11/E4/2.jpg', audioUrl: 'img/FriendsPlus/Page11/Audio/tieude-e4-p11.mp3' },
        { url: 'img/FriendsPlus/Page11/E4/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page11/E4/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page11/E4/5.jpg' },
        { url: 'img/FriendsPlus/Page11/E4/6.jpg', input: 1, },
        { url: 'img/FriendsPlus/Page11/E4/7.jpg', input: 1, isCorrect: true },
        { url: 'img/FriendsPlus/Page11/E4/8.jpg' },
        { url: 'img/FriendsPlus/Page11/E4/9.jpg', input: 2, },
        { url: 'img/FriendsPlus/Page11/E4/10.jpg', input: 2, },
        { url: 'img/FriendsPlus/Page11/E4/11.jpg' },
        { url: 'img/FriendsPlus/Page11/E4/12.jpg', input: 3, },
        { url: 'img/FriendsPlus/Page11/E4/13.jpg', input: 3, },
        { url: 'img/FriendsPlus/Page11/E4/14.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page11/E4/15.jpg' },
        { url: 'img/FriendsPlus/Page11/E4/16.jpg', input: 1, },
        { url: 'img/FriendsPlus/Page11/E4/17.jpg', input: 1, },
        { url: 'img/FriendsPlus/Page11/E4/18.jpg' },
        { url: 'img/FriendsPlus/Page11/E4/19.jpg', input: 2, },
        { url: 'img/FriendsPlus/Page11/E4/20.jpg', input: 2, isCorrect: true },
        { url: 'img/FriendsPlus/Page11/E4/21.jpg' },
        { url: 'img/FriendsPlus/Page11/E4/22.jpg', input: 3, },
        { url: 'img/FriendsPlus/Page11/E4/23.jpg', input: 3, isCorrect: true },
        { url: 'img/FriendsPlus/Page11/E4/24.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page11/E4/25.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page11/E4/26.jpg' },
        { url: 'img/FriendsPlus/Page11/E4/27.jpg', input: 4, },
        { url: 'img/FriendsPlus/Page11/E4/28.jpg', input: 4, },
        { url: 'img/FriendsPlus/Page11/E4/29.jpg' },
        { url: 'img/FriendsPlus/Page11/E4/30.jpg', input: 5, },
        { url: 'img/FriendsPlus/Page11/E4/31.jpg', input: 5, isCorrect: true },
        { url: 'img/FriendsPlus/Page11/E4/32.jpg' },
        { url: 'img/FriendsPlus/Page11/E4/33.jpg', input: 6, isCorrect: true },
        { url: 'img/FriendsPlus/Page11/E4/34.jpg', input: 6, },
        { url: 'img/FriendsPlus/Page11/E4/35.jpg' },
        { url: 'img/FriendsPlus/Page11/E4/36.jpg', input: 7, },
        { url: 'img/FriendsPlus/Page11/E4/37.jpg', input: 7, isCorrect: true },
        { url: 'img/FriendsPlus/Page11/E4/38.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page11/E4/39.jpg' },
        { url: 'img/FriendsPlus/Page11/E4/40.jpg', input: 4, },
        { url: 'img/FriendsPlus/Page11/E4/41.jpg', input: 4, isCorrect: true },
        { url: 'img/FriendsPlus/Page11/E4/42.jpg' },
        { url: 'img/FriendsPlus/Page11/E4/43.jpg', input: 5, },
        { url: 'img/FriendsPlus/Page11/E4/44.jpg', input: 5, },
        { url: 'img/FriendsPlus/Page11/E4/45.jpg' },
        { url: 'img/FriendsPlus/Page11/E4/46.jpg', input: 6, },
        { url: 'img/FriendsPlus/Page11/E4/47.jpg', input: 6, },
        { url: 'img/FriendsPlus/Page11/E4/48.jpg' },
        { url: 'img/FriendsPlus/Page11/E4/49.jpg', input: 7, },
        { url: 'img/FriendsPlus/Page11/E4/50.jpg', input: 7, },
        { url: 'img/FriendsPlus/Page11/E4/51.jpg' },
      ],
      [
        // Column8
        { url: 'img/FriendsPlus/Page11/E4/52.jpg' },
      ],

    ],
  },

  5: { // Exercise num
    unit: 'Unit 1',
    id: 'SB4-U1-P11-E5',
    audio: '',
    video: '',
    recorder: true,
    component: UI,
    questionImage: [ // Row
      [
        { url: 'img/FriendsPlus/Page11/E5/1.jpg' },
      ],
    ],
  },


}

export default json;